import { render, staticRenderFns } from "./triaged.vue?vue&type=template&id=a6fb1740&scoped=true"
import script from "./triaged.vue?vue&type=script&lang=js"
export * from "./triaged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fb1740",
  null
  
)

export default component.exports